/**
 * @fileoverview Second cross-street field for the second company address.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const SecondAddressBetweenStreet2Field = ({ model, t }) => {
  const {
    getFieldValidationState, getErrorMessage,
    handleInputChange, handleFieldChange,
    handleToggleChange, isAddressReadOnly,
    segundoDomicilioEntreCalle2, setSegundoDomicilioEntreCalle2,
    segundoDomicilioMostrarEntreCalle2, setSegundoDomicilioMostrarEntreCalle2,
  } = model;

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {t("components.location.betweenStreet2Label")}
      </label>
      <input
        type="text"
        className={`${styles.input} ${
          getFieldValidationState(
            "domicilio2EntreCalle2",
            segundoDomicilioEntreCalle2,
          ) === "error"
            ? styles.inputError
            : ""
        }`}
        placeholder={t("components.location.betweenStreet2Placeholder")}
        onChange={(e) => {
          const value = e.target.value;
          setSegundoDomicilioEntreCalle2(value);
          handleInputChange("domicilio2EntreCalle2", value);
          handleFieldChange("domicilio2EntreCalle2", value);
        }}
        value={segundoDomicilioEntreCalle2}
        maxLength={100}
        disabled={true}
        style={{ cursor: CURSOR_NOT_ALLOWED }}
      />
      {getErrorMessage("domicilio2EntreCalle2") && (
        <p className={styles.errorMessage}>
          {getErrorMessage("domicilio2EntreCalle2")}
        </p>
      )}
      <div className={styles.showInProfileContainer}>
        <span className={styles.showInProfileText}>
          {t(SHOW_IN_PROFILE_KEY)}
        </span>
        <IconButton
          onClick={() => {
            setSegundoDomicilioMostrarEntreCalle2(
              !segundoDomicilioMostrarEntreCalle2,
            );
            handleToggleChange(
              "domicilio2MostrarEntreCalle2",
              !segundoDomicilioMostrarEntreCalle2,
            );
          }}
          size="small"
          disabled={isAddressReadOnly}
          className={styles.toggleButton}
          sx={{
            "&.Mui-disabled": {
              cursor: CURSOR_NOT_ALLOWED,
              pointerEvents: "auto",
            },
            "& .MuiSvgIcon-root": {
              color: segundoDomicilioMostrarEntreCalle2
                ? TOGGLE_COLOR_ACTIVE
                : TOGGLE_COLOR_INACTIVE,
            },
          }}
        >
          {segundoDomicilioMostrarEntreCalle2 ? (
            <ToggleOnIcon />
          ) : (
            <ToggleOffIcon />
          )}
        </IconButton>
      </div>
    </div>
  );
};

export default SecondAddressBetweenStreet2Field;
